// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3bajB","colCheckbox":"styles_colCheckbox__4OGwT"};